// Service portal cidadao do modulo Aprovacao de Projetos
import { supabase } from '../lib/supabase';

export type TipoObra = 'construcao_nova' | 'reforma' | 'ampliacao' | 'demolicao' | 'regularizacao';
export type ZonaUso = 'residencial' | 'comercial' | 'mista' | 'industrial' | 'rural' | 'institucional';

export const TIPO_OBRA_LABEL: Record<TipoObra, string> = {
  construcao_nova: 'Construção nova',
  reforma: 'Reforma',
  ampliacao: 'Ampliação',
  demolicao: 'Demolição',
  regularizacao: 'Regularização',
};

export const TIPO_OBRA_DESCRICAO: Record<TipoObra, string> = {
  construcao_nova: 'Edificação totalmente nova em terreno vago.',
  reforma: 'Modificações internas/externas mantendo a estrutura.',
  ampliacao: 'Aumento da área construída (acréscimo).',
  demolicao: 'Demolição total ou parcial de edificação existente.',
  regularizacao: 'Regularização de obra já executada sem alvará.',
};

export const ZONA_USO_LABEL: Record<ZonaUso, string> = {
  residencial: 'Residencial',
  comercial: 'Comercial',
  mista: 'Mista',
  industrial: 'Industrial',
  rural: 'Rural',
  institucional: 'Institucional',
};

export interface Exigencia {
  id: string;
  texto: string;
  criada_em: string;
  criada_por: string;
  prazo_dias: number;
  atendida_em: string | null;
  resposta: string | null;
}

export const aprovacaoProjetosPortalService = {
  async submeter(args: {
    estabelecimento_id: string;
    cidadao_id: string;
    tipo_obra: TipoObra;
    descricao_obra: string;
    titulo: string;
    imovel: {
      endereco: string;
      numero: string;
      bairro: string;
      cep: string;
      inscricao_imobiliaria?: string;
      area_terreno?: number;
      area_construcao?: number;
      zona_uso?: ZonaUso;
    };
    responsavel_tecnico: {
      nome: string;
      cpf: string;
      registro: string;
      art_rrt?: string;
    };
  }): Promise<{ id: string; numero: string; hash_publico: string }> {
    const { data, error } = await supabase
      .from('documentos')
      .insert({
        estabelecimento_id: args.estabelecimento_id,
        modulo_codigo: 'aprovacao_projetos',
        titulo: args.titulo,
        descricao: args.descricao_obra,
        status: 'aberto',
        prioridade: 'media',
        visibilidade: 'interna',
        solicitante_cidadao_id: args.cidadao_id,
        campos_customizados: {
          tipo_obra: args.tipo_obra,
          descricao_obra: args.descricao_obra,
          imovel: args.imovel,
          responsavel_tecnico: args.responsavel_tecnico,
          em_exigencia: false,
          exigencias: [],
        },
      })
      .select('id, numero, hash_publico')
      .single();
    if (error) throw error;
    return data as { id: string; numero: string; hash_publico: string };
  },

  async atenderExigencia(args: {
    projeto_id: string;
    exigencia_id: string;
    resposta: string;
  }): Promise<{ ok: boolean; pendentes: number }> {
    const { data, error } = await supabase.rpc('aprovacao_atender_exigencia', {
      p_projeto_id: args.projeto_id,
      p_exigencia_id: args.exigencia_id,
      p_resposta: args.resposta,
    });
    if (error) throw error;
    if (data && typeof data === 'object' && 'erro' in data) {
      throw new Error(String((data as { erro: string }).erro));
    }
    return data as { ok: boolean; pendentes: number };
  },
};

export const ERROS_APROVACAO_PORTAL: Record<string, string> = {
  nao_autenticado: 'Você precisa estar autenticado.',
  projeto_nao_encontrado: 'Projeto não encontrado.',
  apenas_solicitante: 'Apenas o solicitante do projeto pode atender exigências.',
  resposta_curta: 'A resposta deve ter no mínimo 10 caracteres.',
};
